import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Contact() {
  const contactItems = [{
    icon: <MapPinIcon className="w-6 h-6 text-cream" data-id="element-25" />,
    label: 'Location',
    value: 'Beulah Land Farms',
    subValue: 'Pulaski, TN'
  }, {
    icon: <PhoneIcon className="w-6 h-6 text-cream" data-id="element-26" />,
    label: 'Phone',
    value: '(555) 123-4567',
    subValue: 'Mon-Fri, 9am-5pm'
  }, {
    icon: <MailIcon className="w-6 h-6 text-cream" data-id="element-27" />,
    label: 'Email',
    value: 'info@campalkebulan.com',
    subValue: 'We reply within 24 hours'
  }];
  return <section id="contact" className="bg-cream py-20 md:py-28 relative overflow-hidden" data-id="element-28">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-forest/20 to-transparent" data-id="element-29" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-31">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-32">
            <h2 className="font-heading text-forest text-4xl md:text-5xl font-bold mb-4" data-id="element-33">
              Get in Touch
            </h2>
            <div className="w-20 h-1 bg-gold mb-6 rounded-full" data-id="element-34" />
            <p className="text-brown/70 max-w-2xl mx-auto text-lg" data-id="element-35">
              Have questions about registration or our programs? We'd love to
              hear from you.
            </p>
          </motion.div>
        </div>

        {/* Contact Items */}
        <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-12 md:gap-16 lg:gap-24" data-id="element-36">
          {contactItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col items-center text-center group" data-id="element-37">
              <div className="w-16 h-16 rounded-full bg-forest flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:bg-forest-light transition-all duration-300" data-id="element-38">
                {item.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-brown mb-2" data-id="element-39">
                {item.label}
              </h3>
              <p className="text-forest font-medium text-lg mb-1" data-id="element-40">
                {item.value}
              </p>
              <p className="text-brown/60 text-sm" data-id="element-41">{item.subValue}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}